const LegacyCanvasImage = require("./LegacyCanvasImage");
const BaTechCanvasImage = require("./BaTechCanvasImage");
const {getFeatureFlag} = require("./FeatureFlags");

const CanvasImage = getFeatureFlag("ENABLE_BA_TECH")
	? BaTechCanvasImage
	: LegacyCanvasImage;

module.exports = CanvasImage;
